import { createMuiTheme, responsiveFontSizes } from '@material-ui/core'

// colors
const primary = '#c6b3dd'
const secondary = '#403650'
const third = '#72568e'
const black = '#343a40'
const darkBlack = 'rgb(36, 40, 44)'
// const background = '#f5f5f5'
const background = '#faf7fc'
const warningLight = 'rgba(253, 200, 69, .3)'
const warningMain = 'rgba(253, 200, 69, .5)'
const warningDark = 'rgba(253, 200, 69, .7)'

// border
const borderWidth = 2
const borderColor = 'rgba(0, 0, 0, 0.13)'

// breakpoints
const xl = 1920
const lg = 1280
const md = 960
const sm = 600
const xs = 0

// spacing
const spacing = 8

const theme = createMuiTheme({
	palette: {
		primary: { main: third, contrastText: '#fff' },
		secondary: { main: secondary },
		third: { main: third },
		fourth: { main: primary },
		common: {
			black,
			darkBlack,
		},
		warning: {
			light: warningLight,
			main: warningMain,
			dark: warningDark,
		},
		tonalOffset: 0.2,
		background: {
			default: background,
			paper: '#ffffff',
		},
		spacing,
	},
	shape: {
		borderRadius: 12,
	},
	breakpoints: {
		values: {
			xl,
			lg,
			md,
			sm,
			xs,
		},
	},
	border: {
		borderColor: borderColor,
		borderWidth: borderWidth,
	},
	typography: {
		useNextVariants: true,
		fontFamily: 'Poppins, sans-serif',
		h1: { fontWeight: 600 },
		h2: { fontWeight: 600 },
		h3: { fontWeight: 600 },
		h4: { fontWeight: 600 },
		h5: { fontWeight: 600 },
		h6: { fontWeight: 600 },
		button: {
			textTransform: 'none', // More approachable
			fontWeight: 600,
		},
	},
	overrides: {
		MuiButton: {
			root: {
				borderRadius: 25, // Pill shape buttons
				padding: '8px 24px',
			},
			contained: {
				boxShadow: 'none',
				'&:hover': {
					boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
					transform: 'translateY(-1px)',
				},
			},
			containedPrimary: {
				color: '#fff',
			},
		},
		MuiCard: {
			root: {
				borderRadius: 16,
				boxShadow: '0 8px 30px rgba(0,0,0,0.08)',
				transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
				'&:hover': {
					transform: 'translateY(-4px)',
					boxShadow: '0 12px 40px rgba(0,0,0,0.12)',
				},
			},
		},
		MuiPaper: {
			rounded: {
				borderRadius: 16,
			},
			elevation1: {
				boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
			},
		},
		MuiOutlinedInput: {
			root: {
				borderRadius: 12,
				'&:hover $notchedOutline': {
					borderColor: third,
				},
				'&$focused $notchedOutline': {
					borderColor: third,
					borderWidth: 2,
				},
			},
			notchedOutline: {
				borderColor: 'rgba(0,0,0,0.1)',
			},
		},
		MuiExpansionPanel: {
			root: {
				position: 'static',
				borderRadius: 12,
				'&:before': {
					display: 'none',
				},
				marginBottom: spacing,
			},
		},
		MuiTableCell: {
			root: {
				paddingLeft: spacing * 2,
				paddingRight: spacing * 2,
				borderBottom: `1px solid ${borderColor}`,
				[`@media (max-width:  ${sm}px)`]: {
					paddingLeft: spacing,
					paddingRight: spacing,
				},
			},
			head: {
				fontWeight: 600,
				color: secondary,
			},
		},
		MuiDivider: {
			root: {
				backgroundColor: borderColor,
				height: 1,
			},
		},
		MuiListItem: {
			divider: {
				borderBottom: `1px solid ${borderColor}`,
			},
		},
		MuiDialog: {
			paper: {
				width: '100%',
				maxWidth: 430,
				marginLeft: spacing,
				marginRight: spacing,
				borderRadius: 16,
			},
		},
		MuiTooltip: {
			tooltip: {
				backgroundColor: secondary,
				borderRadius: 8,
				fontSize: '0.8rem',
			},
		},
		MuiExpansionPanelDetails: {
			root: {
				[`@media (max-width:  ${sm}px)`]: {
					paddingLeft: spacing,
					paddingRight: spacing,
				},
			},
		},
	},
})

export default responsiveFontSizes(theme)
